/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S2_HeadingInputs */

const tr_hakkimizda_s2_heading = /** @type {(inputs: Hakkimizda_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurucumuzdan`)
};

const en_hakkimizda_s2_heading = /** @type {(inputs: Hakkimizda_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From Our Founder`)
};

const de_hakkimizda_s2_heading = /** @type {(inputs: Hakkimizda_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von unserem Gründer`)
};

const ru_hakkimizda_s2_heading = /** @type {(inputs: Hakkimizda_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`От нашего основателя`)
};

/**
* | output |
* | --- |
* | "From Our Founder" |
*
* @param {Hakkimizda_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s2_heading = /** @type {((inputs?: Hakkimizda_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s2_heading(inputs)
	if (locale === "de") return de_hakkimizda_s2_heading(inputs)
	if (locale === "ru") return ru_hakkimizda_s2_heading(inputs)
	return tr_hakkimizda_s2_heading(inputs)
});